import { ComponentProps } from 'react';
import styled from 'styled-components';
import { IconMenuItem } from './IconMenuItem';

export type IconMenuEntry = Omit<ComponentProps<typeof IconMenuItem>, 'index'>;
export type Props = {
  items: Array<IconMenuEntry | false>;
};

export const IconMenu = ({ items }: Props) => {
  return (
    <IconMenuContainer>
      {items
        .filter((i): i is IconMenuEntry => !!i)
        .map((i, index) => (
          <IconMenuItem key={i.label} index={index} {...i} />
        ))}
    </IconMenuContainer>
  );
};

const IconMenuContainer = styled.div`
  display: flex;
  flex-direction: col;
`;
